import { render, staticRenderFns } from "./registerCompany.vue?vue&type=template&id=0ab31c77&scoped=true"
import script from "./registerCompany.vue?vue&type=script&lang=js"
export * from "./registerCompany.vue?vue&type=script&lang=js"
import style0 from "./registerCompany.vue?vue&type=style&index=0&id=0ab31c77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab31c77",
  null
  
)

export default component.exports